var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleActionAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 1.66667C5.89763 1.66667 2.16667 5.39763 2.16667 10C2.16667 14.6024 5.89763 18.3333 10.5 18.3333C15.1024 18.3333 18.8333 14.6024 18.8333 10C18.8333 5.39763 15.1024 1.66667 10.5 1.66667ZM0.5 10C0.5 4.47715 4.97715 0 10.5 0C16.0228 0 20.5 4.47715 20.5 10C20.5 15.5228 16.0228 20 10.5 20C4.97715 20 0.5 15.5228 0.5 10ZM10.5 5C10.9602 5 11.3333 5.3731 11.3333 5.83333V10C11.3333 10.4602 10.9602 10.8333 10.5 10.8333C10.0398 10.8333 9.66667 10.4602 9.66667 10V5.83333C9.66667 5.3731 10.0398 5 10.5 5ZM10.5 12.5C10.9602 12.5 11.3333 12.8731 11.3333 13.3333V13.75C11.3333 14.2102 10.9602 14.5833 10.5 14.5833C10.0398 14.5833 9.66667 14.2102 9.66667 13.75V13.3333C9.66667 12.8731 10.0398 12.5 10.5 12.5Z",
    fill: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleActionAlert);
export default __webpack_public_path__ + "static/media/Circle-Action-alert.c18c31b9590ae76ef2ec1216ab7500da.svg";
export { ForwardRef as ReactComponent };